import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(location.state?.user ? true : null);
  const [user, setUser] = useState(location.state?.user || null);
  const [isLoading, setIsLoading] = useState(!location.state?.user);

  useEffect(() => {
    // Skip if user data was passed from AuthCallback
    if (location.state?.user) {
      setIsAuthenticated(true);
      setUser(location.state.user);
      setIsLoading(false);
      return;
    }

    const checkAuth = async () => {
      try {
        const response = await fetch(`${BACKEND_URL}/api/auth/me`, {
          credentials: 'include'
        });

        if (!response.ok) {
          throw new Error('Non authentifié');
        }

        const userData = await response.json();
        setUser(userData);
        setIsAuthenticated(true);
      } catch (error) {
        console.error('Auth check failed:', error);
        setIsAuthenticated(false);
        navigate('/admin/login', { replace: true });
      } finally {
        setIsLoading(false);
      }
    };

    checkAuth();
  }, [navigate, location.state]);

  if (isLoading || isAuthenticated === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FFFDF7]">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-[#db3b17] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-[#645E55] font-medium">Chargement...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return null;
  }

  // Clone children and pass user prop
  return (
    <div>
      {typeof children === 'function' ? children({ user }) : children}
    </div>
  );
};

export default ProtectedRoute;
